import { render, staticRenderFns } from "./internasional.vue?vue&type=template&id=a42e58ca&"
import script from "./internasional.vue?vue&type=script&lang=js&"
export * from "./internasional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports